import { render, staticRenderFns } from "./all-class.vue?vue&type=template&id=8933a372&scoped=true"
import script from "./all-class.vue?vue&type=script&lang=js"
export * from "./all-class.vue?vue&type=script&lang=js"
import style0 from "./all-class.vue?vue&type=style&index=0&id=8933a372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8933a372",
  null
  
)

export default component.exports